import React, { useState } from 'react';
import { Button } from 'antd';

import { checkIsCompanyOwner } from 'utils/userRolesUtils';
import SupervisorCard from './SupervisorCard';
import BaseAlert from 'components/wrappers/BaseAlert';
import BasePageCard from 'components/wrappers/BasePageCard';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import EditSupervisorInfoModal from './EditSupervisorInfoModal';
import { ProfileCorporateInfoModel } from 'api/backofficeApiClient';
import { userSelector } from 'redux/selectors/authenticationSelectors';
import { getSupervisorInformation } from 'redux/reducers/accountSlice';
import BaseSectionMessage from 'components/wrappers/BaseSectionMessage';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';

import styles from './SupervisorInfo.module.less';

type Props = {
  corporateInfo?: ProfileCorporateInfoModel;
};

export default function SupervisorInfo(props: Props) {
  const { corporateInfo } = props;
  const user = useAppSelector(userSelector);
  const isCompanyOwner = checkIsCompanyOwner(user);
  const dispatch = useAppDispatch();
  const [supervisorInfo, setSupervisorInfo] = useState(
    corporateInfo?.supervisors,
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const loadSupervisorInfo = async () => {
    const result = await dispatch(getSupervisorInformation());

    if (getSupervisorInformation.fulfilled.match(result)) {
      setSupervisorInfo(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      {isModalVisible && (
        <EditSupervisorInfoModal
          onClose={handleCloseModal}
          onEdit={loadSupervisorInfo}
          supervisorInfo={supervisorInfo}
        />
      )}

      <BasePageCard
        title="Supervisor information"
        className="stretch-card"
        icons={<span className="icon icon-supervisor"></span>}
        subTitle={
          isCompanyOwner &&
          !!supervisorInfo?.length && (
            <Button
              onClick={handleOpenModal}
              className="with-icon mobile-icon-only"
              size="large"
              icon={<span className="icon icon-edit" />}
              data-id="openSupervisorInfoModal"
            >
              Edit
            </Button>
          )
        }
      >
        <div className="scroll-box">
          {!supervisorInfo?.length && isCompanyOwner && (
            <div className="content-wrapper">
              <BaseSectionMessage
                type="info"
                title="Info"
                message={
                  <div className={styles.message}>
                    <span>
                      Please add Supervisor in order to select them in a new
                      assignment.
                    </span>
                    <Button
                      className={styles.button}
                      onClick={handleOpenModal}
                      type="link"
                    >
                      Fill in now.
                    </Button>
                  </div>
                }
              />
            </div>
          )}

          {!!supervisorInfo?.length && (
            <>
              {supervisorInfo.map((supervisor, index) => (
                <SupervisorCard key={index} supervisor={supervisor} />
              ))}
            </>
          )}
        </div>
      </BasePageCard>
    </>
  );
}
